var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgExpired = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 643,
    height: 192,
    viewBox: "0 0 643 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M397.5 70H388.5V62.1552C388.497 61.7419 388.587 61.3321 388.767 60.9494C388.946 60.5667 389.21 60.2187 389.544 59.9254C389.878 59.6322 390.276 59.3994 390.714 59.2406C391.151 59.0818 391.621 59 392.095 59H393.905C394.379 59 394.849 59.0818 395.286 59.2406C395.724 59.3994 396.122 59.6322 396.456 59.9254C396.79 60.2187 397.054 60.5667 397.233 60.9494C397.413 61.3321 397.503 61.7419 397.5 62.1552V70Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.5 127V73.2475C399.5 72.3862 399.174 71.5602 398.593 70.9512C398.013 70.3421 397.226 70 396.405 70H389.595C388.774 70 387.987 70.3421 387.407 70.9512C386.826 71.5602 386.5 72.3862 386.5 73.2475V88.5M399.5 127H391.5M399.5 127H419.5C421.5 127 424.5 126.716 424.5 131C424.5 135.5 424.333 156.333 424.5 166",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M296.961 56.8135C296.144 56.8125 295.335 56.9651 294.576 57.2635C294.167 54.6811 292.85 52.3292 290.862 50.6311C288.874 48.933 286.345 48 283.731 48C281.116 48 278.587 48.933 276.599 50.6311C274.611 52.3292 273.294 54.6811 272.886 57.2635C272.126 56.9636 271.317 56.8108 270.501 56.8135C269.601 56.7609 268.7 56.8928 267.853 57.2009C267.006 57.509 266.231 57.9869 265.576 58.6053C264.92 59.2237 264.398 59.9695 264.041 60.7969C263.684 61.6244 263.5 62.516 263.5 63.4172C263.5 64.3184 263.684 65.2101 264.041 66.0375C264.398 66.865 264.92 67.6108 265.576 68.2291C266.231 68.8475 267.006 69.3254 267.853 69.6335C268.7 69.9416 269.601 70.0735 270.501 70.021H296.961C297.86 70.0735 298.761 69.9416 299.608 69.6335C300.455 69.3254 301.23 68.8475 301.885 68.2291C302.541 67.6108 303.063 66.865 303.42 66.0375C303.777 65.2101 303.961 64.3184 303.961 63.4172C303.961 62.516 303.777 61.6244 303.42 60.7969C303.063 59.9695 302.541 59.2237 301.885 58.6053C301.23 57.9869 300.455 57.509 299.608 57.2009C298.761 56.8928 297.86 56.7609 296.961 56.8135V56.8135Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M494.961 17.8135C494.144 17.8125 493.335 17.9651 492.576 18.2635C492.167 15.6811 490.85 13.3292 488.862 11.6311C486.874 9.93298 484.345 9 481.731 9C479.116 9 476.587 9.93298 474.599 11.6311C472.611 13.3292 471.294 15.6811 470.886 18.2635C470.126 17.9636 469.317 17.8108 468.501 17.8135C467.601 17.7609 466.7 17.8928 465.853 18.2009C465.006 18.509 464.231 18.9869 463.576 19.6053C462.92 20.2237 462.398 20.9695 462.041 21.7969C461.684 22.6244 461.5 23.516 461.5 24.4172C461.5 25.3184 461.684 26.2101 462.041 27.0375C462.398 27.865 462.92 28.6108 463.576 29.2291C464.231 29.8475 465.006 30.3254 465.853 30.6335C466.7 30.9416 467.601 31.0735 468.501 31.021H494.961C495.86 31.0735 496.761 30.9416 497.608 30.6335C498.455 30.3254 499.23 29.8475 499.885 29.2291C500.541 28.6108 501.063 27.865 501.42 27.0375C501.777 26.2101 501.961 25.3184 501.961 24.4172C501.961 23.516 501.777 22.6244 501.42 21.7969C501.063 20.9695 500.541 20.2237 499.885 19.6053C499.23 18.9869 498.455 18.509 497.608 18.2009C496.761 17.8928 495.86 17.7609 494.961 17.8135V17.8135Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M205.503 12.2008C204.454 12.1995 203.414 12.3935 202.438 12.7727C201.912 9.49074 200.22 6.50189 197.665 4.34379C195.11 2.1857 191.86 1 188.5 1C185.14 1 181.89 2.1857 179.335 4.34379C176.78 6.50189 175.088 9.49074 174.562 12.7727C173.586 12.3915 172.546 12.1974 171.497 12.2008C170.341 12.134 169.183 12.3015 168.095 12.6931C167.006 13.0847 166.01 13.6921 165.168 14.4779C164.325 15.2638 163.654 16.2116 163.195 17.2632C162.737 18.3148 162.5 19.448 162.5 20.5932C162.5 21.7385 162.737 22.8717 163.195 23.9233C163.654 24.9749 164.325 25.9227 165.168 26.7085C166.01 27.4944 167.006 28.1018 168.095 28.4933C169.183 28.8849 170.341 29.0525 171.497 28.9857H205.503C206.659 29.0525 207.817 28.8849 208.905 28.4933C209.994 28.1018 210.99 27.4944 211.832 26.7085C212.675 25.9227 213.346 24.9749 213.805 23.9233C214.263 22.8717 214.5 21.7385 214.5 20.5932C214.5 19.448 214.263 18.3148 213.805 17.2632C213.346 16.2116 212.675 15.2638 211.832 14.4779C210.99 13.6921 209.994 13.0847 208.905 12.6931C207.817 12.3015 206.659 12.134 205.503 12.2008V12.2008Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M442.499 159.356C442.499 168.221 439.139 176 435.499 176C431.859 176 428.499 168.288 428.499 159.356C428.499 150.425 435.499 127 435.499 127C435.499 127 442.499 150.492 442.499 159.356Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M435.5 176V179",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M317.5 89H390.5V91.2523V144H352.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M415.5 173H350.5V191H415.5V173Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M297.5 118H251.772C251.169 118 250.591 118.235 250.165 118.652C249.739 119.07 249.5 119.636 249.5 120.227V161",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5 191H350.5V154M350.5 153.944V154M289.318 133.249L314.569 90.5868C314.855 90.103 315.26 89.7025 315.744 89.4244C316.229 89.1462 316.777 89 317.334 89C317.891 89 318.439 89.1462 318.924 89.4244C319.408 89.7025 319.813 90.103 320.099 90.5868L355.032 149.461C355.329 149.952 355.49 150.516 355.5 151.092C355.509 151.668 355.366 152.236 355.085 152.738C354.636 153.579 353.092 155.01 350.5 154",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M340.5 170H326.5V191H340.5V170Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M319.407 148.253H316.797C316.368 148.253 315.944 148.169 315.548 148.005C315.153 147.841 314.793 147.601 314.49 147.298C314.187 146.995 313.947 146.635 313.783 146.239C313.619 145.843 313.534 145.419 313.534 144.991V135.563C313.534 135.135 313.619 134.711 313.783 134.315C313.947 133.919 314.187 133.559 314.49 133.256C314.793 132.953 315.153 132.713 315.548 132.549C315.944 132.385 316.368 132.301 316.797 132.301H319.407C319.835 132.301 320.26 132.385 320.655 132.549C321.051 132.713 321.411 132.953 321.714 133.256C322.017 133.559 322.257 133.919 322.421 134.315C322.585 134.711 322.669 135.135 322.669 135.563V145.036C322.658 145.893 322.309 146.712 321.698 147.314C321.088 147.916 320.264 148.253 319.407 148.253V148.253Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M383.5 173H374.5V191H383.5V173Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M392.5 173H383.5V191H392.5V173Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M350.5 161H304.5V170H350.5V161Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M294.5 139L317.5 102L350.5 154",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M309.5 161L279.488 118L249.5 161H253.5V191H304.5V161H309.5Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M278.5 182H272.714C271.862 182 271.044 181.657 270.441 181.046C269.839 180.435 269.5 179.606 269.5 178.742V169.281C269.5 168.415 269.838 167.584 270.44 166.969C271.042 166.354 271.86 166.006 272.714 166H278.5V182Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M284.294 182H278.5V166H284.294C285.146 166.006 285.962 166.354 286.562 166.969C287.163 167.584 287.5 168.415 287.5 169.281V178.742C287.5 179.169 287.417 179.593 287.256 179.989C287.095 180.384 286.859 180.743 286.561 181.046C286.263 181.348 285.91 181.588 285.521 181.752C285.132 181.916 284.715 182 284.294 182V182Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M269.5 144V135",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M289.5 144V135",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M424.5 191H415.5V169.25C415.5 168.392 415.838 167.569 416.44 166.96C417.042 166.351 417.86 166.006 418.714 166H424.5V191Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M388.5 144V159C388.5 161 387.5 163 385.5 163C382.3 163 360.5 163 350.5 163",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 57H80.5C80.5 57 80.5 57 80.6356 57",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 119H214.843C215.156 118.989 215.46 118.892 215.723 118.718C215.985 118.545 216.195 118.303 216.331 118.018C216.467 117.733 216.522 117.417 216.492 117.102C216.462 116.787 216.346 116.487 216.159 116.234L171.048 58.2818C170.737 57.883 170.341 57.5605 169.889 57.3385C169.437 57.1164 168.941 57.0007 168.438 57H133.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M123.5 119H211.5V191H123.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.405 180.492V190.932",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4225 168.275C25.4225 174.823 23.06 180.493 20.45 180.493C17.84 180.493 15.5 174.823 15.5 168.275C15.5 161.728 20.45 144.515 20.45 144.515C20.45 144.515 25.4225 161.75 25.4225 168.275Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M627.5 181V191",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M632.5 168.775C632.5 175.326 630.119 181 627.489 181C624.858 181 622.5 175.326 622.5 168.775C622.5 162.223 627.489 145 627.489 145C627.489 145 632.5 162.246 632.5 168.775Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 163H166.848C167.149 163 167.444 162.916 167.702 162.757C167.96 162.598 168.17 162.369 168.31 162.096C168.45 161.823 168.515 161.516 168.497 161.209C168.479 160.901 168.379 160.604 168.208 160.35L155.561 141.731C155.409 141.505 155.206 141.321 154.969 141.193C154.732 141.066 154.468 141 154.2 141H134.972",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M163.5 163H133.5V191H163.5V163Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M157.5 169V175",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M104.118 124H93.9046C93.0016 124 92.1357 124.337 91.4972 124.936C90.8587 125.535 90.5 126.348 90.5 127.196V132H107.5V127.196C107.5 126.352 107.144 125.542 106.511 124.944C105.877 124.345 105.017 124.006 104.118 124V124Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M99 150H93.9046C93.0016 150 92.1357 149.655 91.4972 149.04C90.8587 148.425 90.5 147.591 90.5 146.721V132H99V150Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M104.118 150H99V132H107.5V146.721C107.503 147.151 107.418 147.577 107.249 147.974C107.081 148.372 106.832 148.734 106.518 149.038C106.203 149.343 105.829 149.585 105.418 149.75C105.006 149.915 104.564 150 104.118 150V150Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M189.118 128H178.905C178.002 128 177.136 128.337 176.497 128.936C175.859 129.535 175.5 130.348 175.5 131.196V136H192.5V131.196C192.5 130.352 192.144 129.542 191.511 128.944C190.877 128.345 190.017 128.006 189.118 128V128Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M184 154H178.905C178.002 154 177.136 153.655 176.497 153.04C175.859 152.425 175.5 151.591 175.5 150.721V136H184V154Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M189.118 154H184V136H192.5V150.721C192.503 151.151 192.418 151.577 192.249 151.974C192.081 152.372 191.832 152.734 191.518 153.038C191.203 153.343 190.829 153.585 190.418 153.75C190.006 153.915 189.564 154 189.118 154V154Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1183 124H56.9046C56.0016 124 55.1357 124.337 54.4972 124.936C53.8587 125.535 53.5 126.348 53.5 127.196V132H70.5V127.196C70.5 126.352 70.1445 125.542 69.5109 124.944C68.8774 124.345 68.0173 124.006 67.1183 124V124Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M62 150H56.9046C56.0016 150 55.1357 149.655 54.4972 149.04C53.8587 148.425 53.5 147.591 53.5 146.721V132H62V150Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1182 150H62V132H70.4999V146.721C70.5029 147.151 70.4177 147.577 70.2491 147.974C70.0805 148.372 69.8319 148.734 69.5176 149.038C69.2032 149.343 68.8294 149.585 68.4177 149.75C68.0059 149.915 67.5642 150 67.1182 150V150Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M104.118 157H93.9046C93.0016 157 92.1357 157.337 91.4972 157.936C90.8587 158.535 90.5 159.348 90.5 160.196V165H107.5V160.196C107.5 159.352 107.144 158.542 106.511 157.944C105.877 157.345 105.017 157.006 104.118 157V157Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M99 183H93.9046C93.0016 183 92.1357 182.655 91.4972 182.04C90.8587 181.425 90.5 180.591 90.5 179.721V165H99V183Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M104.118 183H99V165H107.5V179.721C107.503 180.151 107.418 180.577 107.249 180.974C107.081 181.372 106.832 181.734 106.518 182.038C106.203 182.343 105.829 182.585 105.418 182.75C105.006 182.915 104.564 183 104.118 183V183Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1183 157H56.9046C56.0016 157 55.1357 157.337 54.4972 157.936C53.8587 158.535 53.5 159.348 53.5 160.196V165H70.5V160.196C70.5 159.352 70.1445 158.542 69.5109 157.944C68.8774 157.345 68.0173 157.006 67.1183 157V157Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M62 183H56.9046C56.0016 183 55.1357 182.655 54.4972 182.04C53.8587 181.425 53.5 180.591 53.5 179.721V165H62V183Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1182 183H62V165H70.4999V179.721C70.5029 180.151 70.4177 180.577 70.2491 180.974C70.0805 181.372 69.8319 181.734 69.5176 182.038C69.2032 182.343 68.8294 182.585 68.4177 182.75C68.0059 182.915 67.5642 183 67.1182 183V183Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M183.478 171C185.457 170.996 187.394 171.579 189.042 172.676C190.69 173.773 191.975 175.335 192.735 177.163C193.494 178.991 193.694 181.004 193.309 182.945C192.924 184.887 191.971 186.671 190.571 188.071C189.171 189.471 187.387 190.424 185.445 190.809C183.504 191.194 181.491 190.994 179.663 190.235C177.835 189.475 176.273 188.19 175.176 186.542C174.079 184.894 173.496 182.957 173.5 180.978C173.5 178.331 174.551 175.794 176.422 173.922C178.294 172.051 180.831 171 183.478 171Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 41H120.5V191H133.5V41Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M117.5 41H136.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M125.05 34.0004H129.037C129.709 33.9955 130.365 34.2181 130.913 34.6368C131.462 35.0555 131.874 35.649 132.092 36.3336L133.5 41H120.5L121.887 36.4969C122.09 35.7666 122.508 35.1275 123.079 34.6769C123.65 34.2263 124.342 33.9888 125.05 34.0004V34.0004Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M133.5 131H139.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 131H211.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 146H211.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 161H211.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M204.5 178H211.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M138.989 171C138.268 170.997 137.552 171.145 136.885 171.434C136.218 171.723 135.612 172.149 135.102 172.686C134.591 173.223 134.187 173.861 133.912 174.563C133.637 175.266 133.497 176.018 133.5 176.778V191H144.499V176.867C144.511 176.099 144.376 175.336 144.104 174.623C143.832 173.91 143.427 173.262 142.914 172.716C142.401 172.169 141.79 171.736 141.116 171.442C140.442 171.147 139.719 170.997 138.989 171V171Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M122.5 191H34.5V119H122.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M36 191H1",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 131H41.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 146H41.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 161H41.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5 178H41.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 131H120.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 146H120.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 161H120.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M116.5 178H120.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M120.5 119H35.1675C34.8569 119.001 34.5523 118.916 34.2882 118.754C34.024 118.592 33.8109 118.36 33.6729 118.083C33.535 117.807 33.4778 117.499 33.5078 117.192C33.5377 116.885 33.6537 116.593 33.8426 116.348L78.2155 57.6538C78.3727 57.4505 78.575 57.2857 78.8067 57.1723C79.0384 57.059 79.2933 57 79.5516 57C79.8099 57 80.0648 57.059 80.2965 57.1723C80.5282 57.2857 80.7305 57.4505 80.8877 57.6538",
    stroke: "#425866",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 57L120.5 109",
    stroke: "#425866",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M596.65 54C597.407 54.0049 598.132 54.3085 598.666 54.8444C599.2 55.3804 599.5 56.1052 599.5 56.8607V87.1393C599.502 87.5141 599.43 87.8856 599.288 88.2326C599.146 88.5796 598.937 88.8951 598.672 89.161C598.407 89.4268 598.092 89.6378 597.745 89.7818C597.398 89.9258 597.026 89.9999 596.65 89.9999H461.369C460.991 90.0024 460.617 89.9301 460.268 89.7872C459.919 89.6443 459.602 89.4337 459.335 89.1676C459.068 88.9014 458.857 88.5851 458.713 88.2369C458.57 87.8887 458.498 87.5156 458.5 87.1393V56.8607C458.5 56.102 458.802 55.3744 459.34 54.8379C459.878 54.3014 460.608 54 461.369 54H584.02",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M516.5 90V173H461.5V90",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M596.5 90H516.5V173H596.5V90Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M503.647 164H475.335C474.963 164.002 474.595 163.932 474.251 163.792C473.908 163.652 473.595 163.447 473.331 163.187C473.068 162.926 472.859 162.617 472.716 162.276C472.573 161.936 472.5 161.57 472.5 161.201V137H506.5V161.201C506.5 161.572 506.426 161.939 506.282 162.281C506.138 162.623 505.928 162.933 505.662 163.193C505.397 163.453 505.082 163.659 504.736 163.797C504.39 163.936 504.02 164.005 503.647 164V164Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M584.626 165H559.374C558.998 165.002 558.624 164.929 558.276 164.784C557.927 164.64 557.61 164.426 557.343 164.157C557.076 163.887 556.864 163.566 556.719 163.213C556.574 162.859 556.5 162.48 556.5 162.098V137H587.5V162.098C587.5 162.48 587.426 162.859 587.281 163.213C587.136 163.566 586.924 163.887 586.657 164.157C586.39 164.426 586.073 164.64 585.724 164.784C585.376 164.929 585.002 165.002 584.626 165V165Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M588.374 135.61C588.457 135.747 588.5 135.903 588.5 136.061C588.5 136.22 588.457 136.375 588.374 136.513C588.292 136.656 588.173 136.776 588.028 136.862C587.883 136.947 587.717 136.995 587.547 137H516.5V127H580.858C581.333 126.999 581.801 127.111 582.22 127.325C582.64 127.539 582.998 127.849 583.263 128.227L588.374 135.61Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M600.5 191H516.5V173H597.599C599 173 600.5 173.5 600.5 176C600.5 178.8 600.5 178 600.5 178",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M495.5 107H482.5V127H495.5V107Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M495.5 137H482.5V164H495.5V137Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M578.5 137H565.5V165H578.5V137Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 173H516.5V144H539.607C540.371 144 541.104 144.297 541.646 144.827C542.188 145.357 542.495 146.076 542.5 146.828V173Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M471.633 135.61C471.546 135.745 471.5 135.902 471.5 136.061C471.5 136.221 471.546 136.377 471.633 136.513C471.71 136.656 471.824 136.776 471.964 136.862C472.104 136.948 472.265 136.995 472.43 137H506.57C506.735 136.995 506.896 136.948 507.036 136.862C507.176 136.776 507.29 136.656 507.367 136.513C507.454 136.377 507.5 136.221 507.5 136.061C507.5 135.902 507.454 135.745 507.367 135.61L502.307 128.228C502.049 127.846 501.696 127.533 501.282 127.319C500.867 127.104 500.404 126.995 499.935 127H479.047C478.576 126.998 478.111 127.109 477.694 127.323C477.277 127.537 476.921 127.848 476.656 128.228L471.633 135.61Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M498.5 102.932C498.5 102.158 498.206 101.415 497.682 100.866C497.158 100.316 496.446 100.005 495.703 100H482.279C481.912 100.002 481.549 100.08 481.21 100.229C480.872 100.378 480.565 100.594 480.307 100.867C480.048 101.139 479.844 101.462 479.706 101.816C479.568 102.17 479.498 102.55 479.5 102.932V104.086C479.498 104.468 479.568 104.847 479.706 105.2C479.845 105.553 480.049 105.875 480.308 106.146C480.566 106.416 480.873 106.631 481.211 106.778C481.55 106.925 481.913 107 482.279 107H495.703C496.445 107 497.156 106.693 497.681 106.147C498.205 105.6 498.5 104.859 498.5 104.086V102.932Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M546.5 101.932C546.5 101.158 546.19 100.415 545.639 99.8656C545.087 99.3162 544.338 99.005 543.555 99H529.445C528.662 99.005 527.913 99.3162 527.361 99.8656C526.81 100.415 526.5 101.158 526.5 101.932V103.086C526.5 103.859 526.81 104.6 527.362 105.147C527.915 105.693 528.664 106 529.445 106H543.555C544.336 106 545.085 105.693 545.638 105.147C546.19 104.6 546.5 103.859 546.5 103.086V101.932Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M580.5 101.932C580.5 101.158 580.19 100.415 579.639 99.8656C579.087 99.3162 578.338 99.005 577.555 99H563.445C562.662 99.005 561.913 99.3162 561.361 99.8656C560.81 100.415 560.5 101.158 560.5 101.932V103.086C560.5 103.859 560.81 104.6 561.362 105.147C561.915 105.693 562.664 106 563.445 106H577.555C578.336 106 579.085 105.693 579.638 105.147C580.19 104.6 580.5 103.859 580.5 103.086V101.932Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M595.474 34.5094H585.086C584.363 34.5683 583.688 34.8993 583.196 35.4365C582.704 35.9737 582.431 36.6779 582.431 37.4088C582.431 38.1397 582.704 38.8438 583.196 39.3811C583.688 39.9183 584.363 40.2493 585.086 40.3081H595.474C595.871 40.3405 596.271 40.2895 596.648 40.1585C597.025 40.0275 597.371 39.8192 597.664 39.5468C597.957 39.2744 598.191 38.9438 598.351 38.5759C598.511 38.2079 598.594 37.8105 598.594 37.4088C598.594 37.0071 598.511 36.6097 598.351 36.2417C598.191 35.8737 597.957 35.5432 597.664 35.2708C597.371 34.9984 597.025 34.7901 596.648 34.6591C596.271 34.528 595.871 34.4771 595.474 34.5094V34.5094Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M543.5 106H529.5V127H543.5V106Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M576.5 106H563.5V127H576.5V106Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M578.505 65.6183L571.249 61.2362L563.993 65.6183C563.566 65.8775 563.212 66.243 562.966 66.6796C562.72 67.1162 562.589 67.6093 562.586 68.1115V82.1644H579.911V68.1115C579.909 67.6093 579.778 67.1162 579.532 66.6796C579.286 66.243 578.932 65.8775 578.505 65.6183V65.6183Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M574.718 82.1645H567.78V73.4381C567.78 72.9801 567.87 72.5267 568.045 72.1038C568.219 71.6809 568.475 71.2969 568.797 70.9739C569.12 70.651 569.502 70.3953 569.923 70.2218C570.344 70.0483 570.794 69.9602 571.249 69.9627V69.9627C571.704 69.9602 572.154 70.0483 572.575 70.2218C572.996 70.3953 573.378 70.651 573.701 70.9739C574.023 71.2969 574.279 71.6809 574.453 72.1038C574.628 72.5267 574.718 72.9801 574.718 73.4381V82.1645Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M585.086 40.3081H595.474V60.0652C595.476 60.4479 595.403 60.8273 595.259 61.1813C595.115 61.5354 594.902 61.857 594.634 62.1276C594.365 62.3982 594.046 62.6124 593.694 62.7577C593.343 62.903 592.966 62.9765 592.586 62.974H587.974C587.208 62.974 586.474 62.6675 585.932 62.122C585.391 61.5765 585.086 60.8367 585.086 60.0652V40.3081Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M548.5 191H542.5V161H545.996C546.325 161 546.65 161.076 546.954 161.224C547.258 161.372 547.534 161.589 547.767 161.862C547.999 162.136 548.184 162.46 548.309 162.818C548.435 163.175 548.5 163.558 548.5 163.945V191Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M523.5 173V153.823C523.498 153.453 523.569 153.087 523.711 152.744C523.853 152.402 524.062 152.09 524.326 151.828C524.59 151.566 524.904 151.357 525.25 151.215C525.596 151.073 525.967 151 526.342 151H532.639C533.398 151 534.126 151.297 534.662 151.827C535.199 152.356 535.5 153.075 535.5 153.823V173",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M516.5 173V191H465.5M458.5 176.003C458.5 175.207 458.8 174.443 459.333 173.88C459.867 173.316 460.591 173 461.345 173",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M542.5 179H516.5V185H542.5V179Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M480.237 76.9324H499.568",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M489.893 68.2061V76.9324",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M562.586 82.1644V85.6399",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M579.911 82.1644V85.6399",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M473.5 185H505.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M559.5 184H592.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M627.18 191H594.292H585.839C585.62 190.443 585.505 189.847 585.5 189.245C585.505 187.98 585.987 186.769 586.84 185.875C587.693 184.981 588.849 184.477 590.056 184.472C591.09 184.489 592.088 184.879 592.88 185.576C593.07 183.703 593.912 181.97 595.246 180.707C596.58 179.444 598.311 178.741 600.109 178.732C601.032 178.731 601.946 178.918 602.801 179.285C603.727 177.076 605.35 175.268 607.397 174.165C609.445 173.061 611.792 172.729 614.046 173.224C616.3 173.718 618.322 175.01 619.775 176.882C621.227 178.755 622.02 181.093 622.022 183.505C622.004 183.902 621.966 184.297 621.909 184.689C622.239 184.577 622.58 184.504 622.925 184.472C623.525 184.469 624.12 184.591 624.675 184.829C625.229 185.068 625.734 185.419 626.159 185.863C626.584 186.306 626.921 186.833 627.151 187.414C627.382 187.994 627.5 188.616 627.5 189.245C627.492 189.845 627.384 190.439 627.18 191ZM627.18 191H642",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M433.292 191H466.18C466.384 190.439 466.492 189.845 466.5 189.245C466.5 188.616 466.382 187.994 466.151 187.414C465.921 186.833 465.584 186.306 465.159 185.863C464.734 185.419 464.229 185.068 463.675 184.829C463.12 184.591 462.525 184.469 461.925 184.472C461.58 184.504 461.239 184.577 460.909 184.689C460.966 184.297 461.004 183.902 461.022 183.505C461.02 181.093 460.227 178.755 458.775 176.882C457.322 175.01 455.3 173.718 453.046 173.224C450.792 172.729 448.445 173.061 446.397 174.165C444.35 175.268 442.727 177.076 441.801 179.285C440.946 178.918 440.032 178.731 439.109 178.732C437.311 178.741 435.58 179.444 434.246 180.707C432.912 181.97 432.07 183.703 431.88 185.576C431.088 184.879 430.09 184.489 429.056 184.472C427.849 184.477 426.693 184.981 425.84 185.875C424.987 186.769 424.505 187.98 424.5 189.245C424.505 189.847 424.62 190.443 424.839 191H433.292Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M229.499 159.356C229.499 168.221 226.139 176 222.499 176C218.859 176 215.499 168.288 215.499 159.356C215.499 150.425 222.499 127 222.499 127C222.499 127 229.499 150.492 229.499 159.356Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M222.5 176V179",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M220.292 191H253.18C253.384 190.439 253.492 189.845 253.5 189.245C253.5 188.616 253.382 187.994 253.151 187.414C252.921 186.833 252.584 186.306 252.159 185.863C251.734 185.419 251.229 185.068 250.675 184.829C250.12 184.591 249.525 184.469 248.925 184.472C248.58 184.504 248.239 184.577 247.909 184.689C247.966 184.297 248.004 183.902 248.022 183.505C248.02 181.093 247.227 178.755 245.775 176.882C244.322 175.01 242.3 173.718 240.046 173.224C237.792 172.729 235.445 173.061 233.397 174.165C231.35 175.268 229.727 177.076 228.801 179.285C227.946 178.918 227.032 178.731 226.109 178.732C224.311 178.741 222.58 179.444 221.246 180.707C219.912 181.97 219.07 183.703 218.88 185.576C218.088 184.879 217.09 184.489 216.056 184.472C214.849 184.477 213.693 184.981 212.84 185.875C211.987 186.769 211.505 187.98 211.5 189.245C211.505 189.847 211.62 190.443 211.839 191H220.292Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M515.67 89.7937C514.984 89.7778 514.328 89.516 513.82 89.0563L488.635 66.6382L463.468 89.0563C463.198 89.3563 462.867 89.5957 462.497 89.7584C462.127 89.9211 461.727 90.0034 461.323 89.9999C460.919 89.9964 460.52 89.9071 460.153 89.738C459.786 89.569 459.459 89.3239 459.195 89.0192C458.93 88.7146 458.734 88.3572 458.618 87.9709C458.503 87.5847 458.472 87.1784 458.526 86.779C458.58 86.3797 458.719 85.9964 458.934 85.6548C459.148 85.3131 459.433 85.0209 459.77 84.7976L486.749 60.7202C487.27 60.2563 487.945 60 488.644 60C489.343 60 490.018 60.2563 490.54 60.7202L517.574 84.7976C517.993 85.1818 518.288 85.6818 518.421 86.2337C518.554 86.7856 518.519 87.3644 518.32 87.8965C518.122 88.4285 517.769 88.8895 517.307 89.2209C516.845 89.5522 516.294 89.7388 515.725 89.7569L515.67 89.7937Z",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M268.5 134H290.5",
    stroke: "#425866",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "5 5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgExpired);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/expired.dd941d095cf17188f5b4cb9707296afe.svg";